module.exports = __webpack_public_path__ + "static/media/laptop-certificate.5cd893f0.png";